var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-month-select", {
    attrs: {
      value: _vm.getSelectedMonth(),
      "use-go-time": "",
      fancy: "",
      label: _vm.label,
      "include-relative-month-values": "",
    },
    on: {
      input: function ($event) {
        return _vm.setMonth($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }